import React from 'react';

/**
 * TokenIcon - Reusable token icon component
 * Replace the emoji 🪙 with a custom PNG image
 * 
 * Usage:
 *   <TokenIcon className="w-5 h-5" />
 *   <TokenIcon size="sm" />
 *   <TokenIcon size="md" />
 *   <TokenIcon size="lg" />
 */
const TokenIcon = ({ 
  className = '', 
  size = 'md',
  alt = 'Token',
  ...props 
}) => {
  // Size presets (you can adjust these)
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
  };

  // If custom className is provided, use it; otherwise use size preset
  const finalClassName = className || sizeClasses[size] || sizeClasses.md;

  return (
    <img
      src="/assets/token-icon.png"
      alt={alt}
      className={`inline-block object-contain flex-shrink-0 ${finalClassName}`}
      style={{ imageRendering: 'auto' }}
      {...props}
    />
  );
};

export default TokenIcon;

